import { Enum } from '@sinclair/typebox';

export enum PAX_TYPE {
  ADULT = 'ADT',
  CHILD = 'CHD',
  INFANT = 'INF',
  YOUTH = 'YTH',
  CHILD_SHORT = 'CH',
  INFANT_SHORT = 'IN',
  UNACCOMPANIED_MINOR = 'UMNR',
}

export enum PAX_GENDER_TITLE {
  MALE = 'Mr',
  FEMALE = 'Ms',
}

export enum PAX_GENDER_PREFIX {
  MALE = 'M',
  FEMALE = 'F',
}

export const MIN_FIRST_NAME_LENGTH = 1;
export const MIN_LAST_NAME_LENGTH = 2;
export const MAX_INFANT_AND_ADULT_NAME_LENGTH = 39;

export type PassengerCount = {
  [PAX_TYPE.ADULT]: number;
  [PAX_TYPE.CHILD]?: number;
  [PAX_TYPE.INFANT]?: number;
  [PAX_TYPE.YOUTH]?: number;
};

export type PassengerType = Exclude<PAX_TYPE, PAX_TYPE.CHILD_SHORT | PAX_TYPE.INFANT_SHORT>;

export const paxType = Enum({
  ADULT: PAX_TYPE.ADULT,
  CHILD: PAX_TYPE.CHILD,
  INFANT: PAX_TYPE.INFANT,
  YOUTH: PAX_TYPE.YOUTH,
  CHILD_SHORT: PAX_TYPE.CHILD_SHORT,
  INFANT_SHORT: PAX_TYPE.INFANT_SHORT,
  UNACCOMPANIED_MINOR: PAX_TYPE.UNACCOMPANIED_MINOR,
});
